import { createFileRoute } from '@tanstack/react-router'

import { Agent2DetailPage } from './_app.agentes.$agentId'

export const Route = createFileRoute('/_app/agentes/$agentId/agendamento')({
  component: () => <Agent2DetailPage activeTab="scheduling" />,
})
